import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import tomtomLogo from '../../images/tomtomLogo.svg';
import tomtomLogoLight from '../../images/tomtomLogoLight.svg';

const useStyles = makeStyles()({
  logo: {
    width: 'auto',
    height: 30,
    display: 'block',
  },
});

export const LogoFull = () => {
  const { classes } = useStyles();
  const theme = useTheme();
  const logoSrc = theme.palette.mode === 'light' ? tomtomLogoLight : tomtomLogo;

  return <img src={logoSrc} className={classes.logo} alt="TomTom" />;
};
